import { Button } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const BtnBox = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  && {
    height: 32px;
    gap: 0;
    text-transform: none;
  }
`;
